import { Modal } from 'antd';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { CustomButtonSupportedIcon } from 'pages/settings/companySettings/components/customButtons/helpers';
import { getCustomButtonSupportedIconByName } from 'pages/settings/companySettings/components/customButtons/helpers';

interface CustomButtonProps {
  button: {
    label?: string;
    color?: string | null;
    requireConfirmation?: boolean;
    forceRefresh?: boolean;
    icon?: string | null;
  };
  onClick: () => Promise<void>;
  disabled?: boolean;
}

const CustomButton = ({ button, onClick, disabled }: CustomButtonProps) => {
  const { tSetting } = useCustomTranslation();
  const [modal, contextHolder] = Modal.useModal();

  const handleButtonClick = async () => {
    if (button.requireConfirmation) {
      return modal.confirm({
        title: tSetting('custom_button_action_confirm'),
        onOk: async () => await onClick()
      });
    }

    return await onClick();
  };

  return (
    <>
      <Button
        type="default"
        disabled={disabled}
        onClick={handleButtonClick}
        icon={
          button.icon ? (
            <Icon
              path={getCustomButtonSupportedIconByName(button.icon as CustomButtonSupportedIcon)}
            />
          ) : undefined
        }
      >
        {button.label}
      </Button>
      {contextHolder}
    </>
  );
};

export default CustomButton;
